export enum MediaQueryLimit {
	SMALL = 600,
	MEDIUM = 1024,
	LARGE = 1300
}
